// Helpers for CRM forms (public pages are served by the backend at /f/:slug).

// Origin that serves /f/:slug. Defaults to the app origin (reverse proxy); override with
// VITE_FORMS_ORIGIN when the backend lives on another origin.
export const formsOrigin = () =>
  (import.meta.env.VITE_FORMS_ORIGIN || window.location.origin).replace(/\/$/, '');

export const publicFormUrl = (slug) => `${formsOrigin()}/f/${slug}`;

export const slugify = (text) =>
  String(text || '')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
    .slice(0, 60);

export const STATUS_LABELS = {
  draft: { label: 'Rascunho', color: 'bg-slate-100 text-slate-600' },
  published: { label: 'Publicado', color: 'bg-green-100 text-green-700' },
  archived: { label: 'Arquivado', color: 'bg-yellow-100 text-yellow-700' },
};

export const pct = (v) => `${((Number(v) || 0) * 100).toFixed(1).replace('.', ',')}%`;

export const DEFAULT_SCHEMA = {
  theme: { primaryColor: '#1F6FEB', backgroundColor: '#F5F7FA', logoShape: 'circle' },
  welcome: { enabled: true, title: '', text: '', cta: 'Começar' },
  questions: [
    { id: 'q1', type: 'name', label: 'Seu nome', required: true },
    { id: 'q2', type: 'phone', label: 'WhatsApp', required: true },
  ],
  endScreen: { title: 'Obrigado!', text: 'Suas respostas foram registradas.' },
  abandonment: { minutes: 30 },
};

// Friendly message for API errors (403 = no permission for Formulários).
export const apiErrorMessage = (err, fallback) =>
  err?.status === 403 ? 'Você não tem permissão para acessar Formulários.' : (err?.message || fallback);
